export default __webpack_public_path__ + "static/media/investors.75f77d1c.wav";